/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { SSEErrorType } from '../middlewares/SSEMiddelware';
import { MainStatisticsDto } from '../api/mainStatistics/mainStatisticsClient.typings';

export enum InspectorHomeActionType {
    SSE_OPEN = 'InspectorHome/ SSE open',
    SSE_CONNECTING = 'InspectorHome/ SSE connecting',
    SSE_CLOSED = 'InspectorHome/ SSE closed',
    SSE_ON_MESSAGE = 'InspectorHome/ SSE on message',
    SSE_ERROR = 'InspectorHome/ SSE error',
}

export const SSEConnecting = () => {
    console.log('SSE connection...');
    return createAction(InspectorHomeActionType.SSE_CONNECTING);
};

export const SSEOpen = () => {
    console.log('SSE open.');
    return createAction(InspectorHomeActionType.SSE_OPEN);
};

export const SSEClosed = () => {
    console.log('SSE closed');
    return createAction(InspectorHomeActionType.SSE_CLOSED);
};

export const SSEOnMessage = (message: MainStatisticsDto) => {
    return createAction(InspectorHomeActionType.SSE_ON_MESSAGE, message);
};

export const SSEError = (error: SSEErrorType) => {
    console.error('Error:', error);
    return createAction(InspectorHomeActionType.SSE_ERROR, error);
};

export type InspectorHomeAction =
    | ReturnType<typeof SSEOpen>
    | ReturnType<typeof SSEConnecting>
    | ReturnType<typeof SSEClosed>
    | ReturnType<typeof SSEOnMessage>
    | ReturnType<typeof SSEError>;
